var initializeMobileNavigationButton;

(function($) {
    initializeMobileNavigationButton = function(button, layer) {
        // check if button exists
        if(button.length) {
            // Mobile Menu
            button.on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                button.toggleClass('active');
                layer.toggleClass('open');
                $('body').toggleClass('body-fixed');

                // display metanav
                if($('.meta-nav').hasClass('collapsed')) {
                    $('.meta-nav').removeClass('collapsed');
                }

            });

            // slide out mobile navigation if clicked outside
            layer.on('click', function(e) {
                if($(e.target).hasClass('mobile-nav')) {
                    layer.removeClass('open');
                    button.removeClass('active');
                    $('body').removeClass('body-fixed');
                }
            });
        }
    }

})(jQuery);